module.exports = __webpack_public_path__ + "img/thigh.78c6d65c.png";